  <div class="row"*ngIf="user.usertype=='Metier'">
    <div class="col-sm-6 col-md-4">
      <div class="card card-stats card-primary card-round">
        <div class="card-body">
          <div class="row">
            <div class="col-5">
              <div class="icon-big text-center">
                <i class="fas fa-users"></i>
              </div>
            </div>
            <div class="col-7 col-stats">
              <div class="numbers">
                <p class="card-category">Total reclamations</p>
                <h4 class="card-title">{{totalrecs}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-md-4">
      <div class="card card-stats card-info card-round">
        <div class="card-body">
          <div class="row">
            <div class="col-5">
              <div class="icon-big text-center">
                <i class="fas fa-user-check"></i>
              </div>
            </div>
            <div class="col-7 col-stats">
              <div class="numbers">
                <p class="card-category">Total reclamations actives</p>
                <h4 class="card-title">{{totalrecsactif}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-md-4">
      <div class="card card-stats card-success card-round">
        <div class="card-body">
          <div class="row">
            <div class="col-5">
              <div class="icon-big text-center">
                <i class="fas fa-chart-pie"></i>
              </div>
            </div>
            <div class="col-7 col-stats">
              <div class="numbers">
                <p class="card-category">Total reclamations cloturées</p>
                <h4 class="card-title">{{totalrecscloture}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row"*ngIf="user.usertype=='Metier'" >
    <div class="col-md-4"*ngFor="let col of totalrectypes; let i = index">
      <div class="card card-secondary bg-secondary-gradient">
        <div class="card-body skew-shadow">
          <img
            [src]=col.path
            height="12.5"
          />
          <div class="row">
            <div class="col-8 pe-0">
              <h3 class="fw-bold mb-1">{{col.libelle}}</h3>
            </div>
            <div class="col-4 ps-0 text-end">
              <h3 class="fw-bold mb-1">{{col.total}}</h3>
              <div class="text-small text-uppercase fw-bold op-8">
                <h6 class="fw-bold mb-1" style="text-decoration: underline; cursor: pointer;"><a [routerLink]="['/dashboard/user-board/', col.type]"target="_self" routerLinkActive="active">Consulter</a></h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
      <div class="card card-round">
        <div class="card-header">
          <div class="card-head-row card-tools-still-right">
            <div class="card-title">Réclamations à traiter <span class="badge bg-grd-info text-dark">{{totalrecstotreattotal}}</span></div>
            <div class="card-tools">
              <div class="dropdown">
                <button
                  class="btn btn-icon btn-clean me-0"
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="fas fa-ellipsis-h"></i>
                </button>
                <div
                  class="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                >
                  <a class="dropdown-item" href="#">Action</a>
                  <a class="dropdown-item" href="#">Another action</a>
                  <a class="dropdown-item" href="#"
                    >Something else here</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <!-- Projects table -->
            <table class="table align-items-center mb-0">
              <thead class="thead-light">
                <tr>
                  <th scope="col">Code</th>
                  <th scope="col" class="text-end">Date de création</th>
                  <th scope="col" class="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let rec of totalrecstotreat; let i = index">
                  <th scope="row">
                    <button
                      class="btn btn-icon btn-round btn-success btn-sm me-2"
                    >
                      <i class="fa fa-check"></i>
                    </button>
                    {{rec.ref}}{{rec.refprefixe}}
                  </th>
                  <td class="text-end">{{rec.created |customDate:'yes'}}</td>
                  <td class="text-end">
                    <button type="button" class="btn btn-success" (click)="getNavigation('reclamation/create-reclamation',rec._id,rec)">Traiter</button>                
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
  </div>

